import { authenticatedRequest } from '@app/rest/rest.lib'

import type { IApiIntegration } from './interfaces'

export interface CreateIntegrationResponse {
  id: string
}

export function uploadConfiguration(i: IApiIntegration) {
  return authenticatedRequest({
    method: 'post',
    url: `/api/v2/integration/config`,
    data: {
      config: i,
    },
  })
}

export interface ListIntegrationsResponse {
  integrations: IApiIntegration[]
}

export function fetchIntegrations() {
  return authenticatedRequest({
    method: 'get',
    url: `/api/v2/integrations`,
  })
}
